/**
 * OSC 52: copiar da maquina remota para a area de transferencia de quem olha.
 *
 * O daemon roda onde o codigo esta -- aqui, uma VPS headless, sem DISPLAY e
 * portanto sem `xclip` funcional. Quando um agente copia algo, ele cai no
 * OSC 52, que existe exatamente para isso: a sequencia viaja pelo PTY ate o
 * terminal, e quem escreve no clipboard e o terminal, no computador do usuario.
 *
 * Sem alguem tratando essa sequencia o xterm a descarta calado, e o sintoma
 * chega como "cliquei em copiar e o Ctrl+V nao traz nada" -- sem erro em lugar
 * nenhum, porque do lado do agente a copia foi bem-sucedida.
 *
 * Logica pura, sem DOM, para poder ser testada: o TerminalPane so liga isto ao
 * `registerOscHandler` e entrega o texto ao navegador.
 */

/**
 * Extrai o texto de um payload de OSC 52, ou `null` quando nao ha o que copiar.
 *
 * O payload vem como `<alvo>;<base64>`, onde o alvo diz qual area de
 * transferencia (`c` para a principal, `p` para a primaria do X).
 */
export function decodeOsc52(data: string): string | null {
  const corte = data.indexOf(';');
  if (corte === -1) return null;

  const carga = data.slice(corte + 1);

  // `?` nao e uma escrita: e uma CONSULTA, pedindo o conteudo atual de volta
  // para o processo remoto. Responder significaria ler a area de transferencia
  // do usuario -- que pode ter uma senha colada ha dez segundos -- e manda-la
  // para um processo rodando em outro lugar. Recusamos de proposito.
  if (carga === '?' || carga === '') return null;

  try {
    const bytes = Uint8Array.from(atob(carga), (c) => c.charCodeAt(0));
    const texto = new TextDecoder().decode(bytes);
    return texto.length > 0 ? texto : null;
  } catch {
    // Base64 malformado. O terminal ignoraria; nos tambem.
    return null;
  }
}
